import { applyStepsWithConfig } from '../../e2e/merchant.utils';
import { PRE_ASSESSMENT_STEP_PATHS } from '../../../../apps/products-eu-fe/src/constants/paths';

export const signup = {
  country: 'BE',
};

export const prefillInformation = {
  averageOrderValue: 150,
  goodsCategory: 'ADULT_SHOES_AND_CLOTHING',
  paymentDelay: 21,
  paymentInterval: 'DAILY',
  registrationCountry: signup.country,
  storeUrl: 'http://test.com',
  customerSupportEmail: 'test@test.com',
  mainSellingCountry: 'BE',
  products: [
    {
      selling_country: 'BE',
      yearly_acquired_volume: 80,
      channels: ['ONLINE'],
      product_name: 'PAY_LATER_BY_CARD',
    },
    {
      selling_country: 'BE',
      yearly_acquired_volume: 80,
      channels: ['ONLINE'],
      product_name: 'PAY_NOW_BANK_TRANSFER',
    },
    {
      selling_country: 'BE',
      yearly_acquired_volume: 80,
      channels: ['ONLINE'],
      product_name: 'KCO_GLOBAL',
    },
    {
      selling_country: 'BE',
      yearly_acquired_volume: 80,
      channels: ['ONLINE'],
      product_name: 'SOFORT_CLASSIC',
    },
    {
      selling_country: 'AT',
      yearly_acquired_volume: 80,
      channels: ['ONLINE'],
      product_name: 'PAY_LATER_IN_14',
    },
    {
      selling_country: 'AT',
      yearly_acquired_volume: 80,
      channels: ['ONLINE'],
      product_name: 'FINANCING_FIXED',
    },
    {
      selling_country: 'AT',
      yearly_acquired_volume: 80,
      channels: ['ONLINE'],
      product_name: 'KCO_AMEX',
    },
    {
      selling_country: 'AT',
      yearly_acquired_volume: 80,
      channels: ['ONLINE'],
      product_name: 'SOFORT_CLASSIC',
    },
    {
      selling_country: 'SE',
      yearly_acquired_volume: 80,
      channels: ['ONLINE'],
      product_name: 'PAY_LATER_IN_30',
    },
    {
      selling_country: 'SE',
      yearly_acquired_volume: 80,
      channels: ['ONLINE'],
      product_name: 'FINANCING_FIXED',
    },
    {
      selling_country: 'SE',
      yearly_acquired_volume: 80,
      channels: ['ONLINE'],
      product_name: 'KCO_AMEX',
    },
    {
      selling_country: 'SE',
      yearly_acquired_volume: 80,
      channels: ['ONLINE'],
      product_name: 'SOFORT_CLASSIC',
    },
    {
      selling_country: 'DE',
      yearly_acquired_volume: 80,
      channels: ['ONLINE'],
      product_name: 'PAY_LATER_IN_30',
    },
    {
      selling_country: 'DE',
      yearly_acquired_volume: 80,
      channels: ['ONLINE'],
      product_name: 'FINANCING_FIXED',
    },
    {
      selling_country: 'DE',
      yearly_acquired_volume: 80,
      channels: ['ONLINE'],
      product_name: 'KCO_B2B',
    },
    {
      selling_country: 'DE',
      yearly_acquired_volume: 80,
      channels: ['ONLINE'],
      product_name: 'SOFORT_CLASSIC',
    },
    {
      selling_country: 'NL',
      yearly_acquired_volume: 80,
      channels: ['ONLINE'],
      product_name: 'PAY_LATER_IN_30',
    },
    {
      selling_country: 'NL',
      yearly_acquired_volume: 80,
      channels: ['ONLINE'],
      product_name: 'PAY_NOW_DIRECT_DEBIT',
    },
    {
      selling_country: 'NL',
      yearly_acquired_volume: 80,
      channels: ['ONLINE'],
      product_name: 'KCO_AMEX',
    },
    {
      selling_country: 'NL',
      yearly_acquired_volume: 80,
      channels: ['ONLINE'],
      product_name: 'SOFORT_CLASSIC',
    },
  ],
};

export const prefillHighPML = {
  ...prefillInformation,
  paymentDelay: 3,
  products: [
    ...prefillInformation.products,
    {
      selling_country: 'FR',
      channels: ['ONLINE'],
      yearly_acquired_volume: 25000000,
      product_name: 'PAY_LATER_BY_CARD',
    },
    {
      selling_country: 'FR',
      channels: ['ONLINE'],
      yearly_acquired_volume: 25000000,
      product_name: 'PAY_NOW_CARD_STANDARD',
    },
    {
      selling_country: 'FR',
      channels: ['ONLINE'],
      yearly_acquired_volume: 25000000,
      product_name: 'UNBRANDED_CARD_STANDARD',
    },
    {
      selling_country: 'FR',
      channels: ['ONLINE'],
      yearly_acquired_volume: 25000000,
      product_name: 'SOFORT_CLASSIC',
    },
  ],
};

export const prefillHighExposure = {
  ...prefillHighPML,
  goodsCategory: 'TRAVEL_SERVICES',
};

export const companyDetails = {
  companyName: 'Test Company',
  registrationNumber: '1234561234',
  operatingCountry: 'BE',
};

export const questionnaires = {
  businessConcepts: ['AUCTIONS', 'MARKETPLACES'],
  questionnaires: [
    {
      path: PRE_ASSESSMENT_STEP_PATHS.BUSINESS_CONCEPT_AUCTIONS_QUESTIONNAIRE,
      answers: [
        'Answer 1.',
        'Answer 2.',
        'Answer 3.',
        'Answer 4.',
        'Answer 5.',
        'Answer 6.',
        'Answer 7.',
        'Answer 8.',
        'Answer 9.',
      ],
    },
    {
      path: PRE_ASSESSMENT_STEP_PATHS.BUSINESS_CONCEPT_MARKETPLACES_QUESTIONNAIRE,
      answers: [
        'Answer 1.',
        'Answer 2.',
        'Answer 3.',
        'Answer 4.',
        'Answer 5.',
        'Answer 6.',
        'Answer 7.',
        'Answer 8.',
        'Answer 9.',
        'Answer 10.',
      ],
    },
  ],
};

export const highPMLQuestionnaires = {
  businessConcepts: ['MARKETPLACES', 'TOBACCO'],
  questionnaires: [
    {
      path: PRE_ASSESSMENT_STEP_PATHS.HIGH_PML_QUESTIONNAIRE,
      answers: ['Answer 1.', 'Answer 2.'],
    },
    {
      path: PRE_ASSESSMENT_STEP_PATHS.BUSINESS_CONCEPT_MARKETPLACES_QUESTIONNAIRE,
      answers: [
        'Answer 1.',
        'Answer 2.',
        'Answer 3.',
        'Answer 4.',
        'Answer 5.',
        'Answer 6.',
        'Answer 7.',
        'Answer 8.',
        'Answer 9.',
        'Answer 10.',
      ],
    },
    {
      path: PRE_ASSESSMENT_STEP_PATHS.BUSINESS_CONCEPT_TOBACCO_QUESTIONNAIRE,
      answers: ['Answer 1.', 'Answer 2.', 'Answer 3.', 'Answer 4.'],
    },
  ],
};

export const highExposureQuestionnaires = {
  goodsCategory: 'TRAVEL_SERVICES',
  businessConcepts: ['VOUCHER', 'TOBACCO', 'AUCTIONS'],
  questionnaires: [
    {
      path: PRE_ASSESSMENT_STEP_PATHS.HIGH_EXPOSURE_SEGMENT_TRAVEL_SERVICES_QUESTIONNAIRE,
      answers: ['Answer 1.', 'Answer 2.', 'Answer 3.'],
    },
    {
      path: PRE_ASSESSMENT_STEP_PATHS.HIGH_EXPOSURE_BUSINESS_CONCEPT_VOUCHER_QUESTIONNAIRE,
      answers: ['Answer 1.', 'Answer 2.', 'Answer 3.'],
    },
    {
      path: PRE_ASSESSMENT_STEP_PATHS.BUSINESS_CONCEPT_AUCTIONS_QUESTIONNAIRE,
      answers: [
        'Answer 1.',
        'Answer 2.',
        'Answer 3.',
        'Answer 4.',
        'Answer 5.',
        'Answer 6.',
        'Answer 7.',
        'Answer 8.',
        'Answer 9.',
      ],
    },
    {
      path: PRE_ASSESSMENT_STEP_PATHS.BUSINESS_CONCEPT_TOBACCO_QUESTIONNAIRE,
      answers: ['Answer 1.', 'Answer 2.', 'Answer 3.', 'Answer 4.'],
    },
  ],
};

export const applyStepConfig = {
  signup: {
    value: signup,
    method: 'spreadProperty',
    path: null,
  },
  prefillInformation: {
    value: prefillInformation,
    method: 'spreadProperty',
    path: 'prefillInformation',
  },
  companyDetails: {
    value: companyDetails,
    method: 'spreadProperty',
    path: null,
  },
  questionnaires: {
    value: questionnaires,
    method: 'spreadProperty',
    path: null,
  },
  highPMLQuestionnaires: {
    value: highPMLQuestionnaires,
    method: 'spreadProperty',
    path: null,
  },
  highExposureQuestionnaires: {
    value: highExposureQuestionnaires,
    method: 'spreadProperty',
    path: null,
  },
};

export const getPreAssessmentWithSteps = applyStepsWithConfig(applyStepConfig);
